/**
 * Is In Business Subdomain
 * @desc this method check if the url is with business subdomain
 * @param {string} url - from FiverrContext
 * @returns {boolean} - true if the user includes business. in the url host
 */
const isInBusinessSubdomain = (url) => {
    const host = new URL(url).host;

    return host.includes('business.');
};

module.exports = {
    isInBusinessSubdomain
};
